/** Repairs and Parts pages: fades cards in as they scroll into view. The page works the same without this file. */

(function () {
  const root = document.querySelector('.repairs');
  if (!root || !('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const items = root.querySelectorAll('.rgrid > *, .repair-cards > *, .media-row, .rband, .rnote');
  items.forEach((item) => {
    const siblings = Array.from(item.parentElement.children);
    const index = siblings.indexOf(item) % 4;
    item.setAttribute('data-reveal', '');
    item.style.setProperty('--reveal-delay', index * 70 + 'ms');
  });
  root.classList.add('is-revealing');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );
  items.forEach((item) => observer.observe(item));
})();

/**
 * Repair request form: shows and requires the home address only when the customer picks in-home service.
 * Links to #request-shop or #request-home preselect that choice and jump to the form. The form works without this file.
 */
(function () {
  const form = document.getElementById('repair-request-form');
  if (!form) return;
  const address = form.querySelector('[data-repair-address]');
  const radios = form.querySelectorAll('[data-where]');
  if (!address || !radios.length) return;
  const fields = address.querySelectorAll('[data-address-field]');

  function update() {
    const picked = form.querySelector('[data-where]:checked');
    const isHome = picked && picked.dataset.where === 'home';
    address.hidden = !isHome;
    fields.forEach((field) => {
      field.required = isHome;
    });
  }

  function fromHash() {
    const match = window.location.hash.match(/^#request-(shop|home)$/);
    if (!match) return;
    const radio = form.querySelector('[data-where="' + match[1] + '"]');
    if (radio) radio.checked = true;
    update();
    document.getElementById('request').scrollIntoView({ block: 'start' });
  }

  radios.forEach((radio) => radio.addEventListener('change', update));
  window.addEventListener('hashchange', fromHash);
  update();
  fromHash();
})();
